/**
 * @type string
 */
export const ANDROID_CLIENT_ID = process.env.VUE_APP_ANDROID_CLIENT_ID || '';

/**
 * @type string
 */
export const ANDROID_REDIRECT_URI = process.env.VUE_APP_ANDROID_REDIRECT_URI || '';

/**
 * @type number
 */
export const CACHE_GENERAL_TTL = parseInt(process.env.VUE_APP_CACHE_GENERAL_TTL || '300000'); // 5 minutes in milliseconds

/**
 * Special header to authorize against poisoned requests
 *
 * @type string
 */
export const CS_HEADER = process.env.VUE_APP_CS_HEADER || '';

/**
 * Default latitude until we get it from the device
 *
 * @type number
 */
export const DEFAULT_LATITUDE = parseFloat(process.env.VUE_APP_DEFAULT_LATITUDE || '0');

/**
 * Default longitude until we get it from the device
 *
 * @type number
 */
export const DEFAULT_LONGITUDE = parseFloat(process.env.VUE_APP_DEFAULT_LONGITUDE || '0');

/**
 * How many default photos we have (+1, for Math.floor)
 *
 * @type number
 */
export const DEFAULT_USER_PHOTO_COUNT = parseInt(process.env.VUE_APP_DEFAULT_USER_PHOTO_COUNT || '15');

/**
 * If we should use a splash screen for the app
 *
 * @type boolean
 */
export const ENABLE_SPLASH = !!process.env.VUE_APP_ENABLE_SPLASH || false;

/**
 * Our API server handles REST+Socket requests like storing data,
 * authenticating users, and serving up images.
 *
 * @type string
 */
export const SERVER_URL = process.env.VUE_APP_SERVER_URL || 'https://api.chalkysticks.com/v3';

/**
 * Where our application sends someone to authenticate with Google
 *
 * @type string
 */
export const GOOGLE_AUTH_REDIRECT = process.env.VUE_APP_GOOGLE_AUTH_REDIRECT || `${SERVER_URL}/auth/google`;

/**
 * Where our API server redirects us after a successful Google auth
 *
 * @type string
 */
export const GOOGLE_AUTH_CALLBACK = process.env.VUE_APP_GOOGLE_AUTH_CALLBACK || location.href;

/**
 * Google Maps API key
 *
 * @type string
 */
export const GOOGLE_MAP_API = process.env.VUE_APP_GOOGLE_MAP_API || '';

/**
 * Default zoom for the map
 *
 * @type number
 */
export const GOOGLE_MAP_ZOOM = parseInt(process.env.VUE_APP_GOOGLE_MAP_ZOOM || '16');

/**
 * Where to redirect to after a successful logout
 *
 * @type string
 */
export const LOGOUT_REDIRECT = process.env.VUE_APP_LOGOUT_REDIRECT || '/';

/**
 * Time between showing the splash screen again. Defaults to 24 hours
 * so they see it once a day but not repeatedly throughout the day.
 *
 * @type number
 */
export const SPLASH_TIMEOUT = parseFloat(process.env.VUE_APP_SPLASH_TIMEOUT || '86400000'); // 24 hours in milliseconds

/**
 * @type string
 */
export const STORAGE_KEY = 'chalkysticks-app';

/**
 * If the authentication system should be enabled
 *
 * @type string
 */
export const USE_AUTHENTICATION = !!process.env.VUE_APP_USE_AUTHENTICATION || false;

/**
 * If we include the Analytics in this app
 *
 * @type string
 */
export const USE_ANALYTICS = true;

/**
 * If we include the Pad in this app
 *
 * @type string
 */
export const USE_PAD = true;

/**
 * If we include the Trainer in this app
 *
 * @type string
 */
export const USE_TRAINER = true;

/**
 * Build app version
 *
 * @type string
 */
export const VERSION = process.env.VUE_APP_VERSION || '0.0.0';

/**
 * Pad version
 *
 * @type string
 */
export const PAD_VERSION = '3.1.0';

/**
 * Trainer version
 *
 * @type string
 */
export const TRAINER_VERSION = '2.1.0';

/**
 * The release BEFORE we added version history. This is used so
 * we can track version history starting from this version.
 *
 * @type string
 */
export const VERSION_HISTORY_START_VERSION = '3.27.0';
